import { memoryCache } from 'mihoyo-store';
import { CACHE_INSTANCE_ID, CACHE_USER_LIST } from '@configPath/cacheConfigs/memoryCache.config';
import customEvent from 'mihoyo-custom-event';
import tpl from './porn.tpl';
import best from './best.tpl';
import main from '../main';

import model from '../../models/default';

// memoryCache的存在仅仅是为了演示多个模块之间共享数据的方法，可删除相关代码
// const memoryCache = Store.getInstance();

export default {

  /**
   * 视图容器对象
   * @returns {jQuery|HTMLElement}
   */

  bestAward() {
    return $('.best-award');
  },

  firstAward() {
    return $('.first-award');
  },

  secondAward() {
    return $('.second-award');
  },

  thirdAward() {
    return $('.third-award');
  },

  /**
   * 视图渲染方法
   */
  render() {
    model.initialAward().then(({show_list, is_show, start_time, end_time}) => {
      if (is_show) {
        $('.page-3-bg-not').toggleClass('page-3-bg-not page-3-bg');
        this.bestAward().html(template.render(best, show_list[0].list));
        this.firstAward().html(template.render(tpl, show_list[1].list));
        this.secondAward().html(template.render(tpl, show_list[2].list));
        this.thirdAward().append(template.render(tpl, show_list[3].list));
        main.imgSumHandler('.awards img');
      } else {
        $('.page-3-bg-not').html('');
      }
    }).fail(main.handleFail);
    this.events();
  },

  /**
   * 视图事件集中绑定
   */
  events() {
    $('.award').on('click', 'img', (e) => {
      main.fs(e);
    });
  }
}